import { useEffect, useRef } from "react";

import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

import { createPercentFormatter } from "../../../../utils/formatter/formatter";

export const PerformanceChartVertical = ({ ctx }) => {
  const { data } = ctx || {};



  const labels = data?.map(item => item.rangeName) || [];
  const salesData = data?.map(item => item.salesPercentual) || [];
  const inventoryData = data?.map(item => item.inventoryPercentual) || [];

  const datasets = [
    {
      label: "Vendas",
      data: salesData,
      backgroundColor: "#FF7A21",
      barThickness: 56,
      categoryPercentage: 0.6,
      barPercentage: 0.6,
      datalabels: {
        font: { weight: "700" }
      }
    },
    {
      label: "Estoque",
      data: inventoryData,
      backgroundColor: "#FFDCC6",
      barThickness: 56,
      categoryPercentage: 0.6,
      barPercentage: 0.6
    }
  ];

  const chartRef = useRef(null);

  useEffect(() => {
    if (!chartRef.current) return;

    Chart.plugins.register([ChartDataLabels]);

    const ctx2d = chartRef.current.getContext("2d");

    if (chartRef.current._chartInstance) {
      chartRef.current._chartInstance.destroy();
    }

    chartRef.current._chartInstance = new Chart(ctx2d, {
      type: "bar",
      data: { labels, datasets },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        events: [],
        interaction: { mode: null },
        plugins: {
          tooltip: { enabled: false },
          legend: { display: true, position: "bottom" },
          datalabels: {
            anchor: "end",
            align: "top",
            formatter: (value) => createPercentFormatter().format(value),
            color: "#333",
            font: { weight: "300" }
          }
        },
        scales: {
          x: {
            ticks: { color: "#000", font: { weight: "300" } },
            grid: { drawOnChartArea: false, color: "rgba(0,0,0,0.12)" }
          },
          y: {
            beginAtZero: true,
            grid: { drawOnChartArea: true, color: "rgba(0,0,0,0.20)", lineWidth: 1 }
          }
        }
      }
    });

    return () => {
      chartRef.current?._chartInstance?.destroy();
    };
  }, [labels, salesData, inventoryData]);

  return <canvas ref={chartRef} style={{ width: "60%", height: "60%" }} />;
};
